module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"start":{"news":{"button":"Alle Beiträge ansehen","description":"Ausgewählte Beiträge unserer Experten und Partner","title":"Top Themen der Woche"}}}}}}')
  delete Component.options._Ctor
}
